module.exports = __webpack_public_path__ + "static/offer-envelope-back-8fc28640031f709379b550903802e6a0.png";